module.exports = __webpack_public_path__ + "static/img/preview-5.13a0fd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/zombs/preview-5.png
// module id = hsqj
// module chunks = 35